import { toNumber } from "./number.mjs";
export const formatCurrency = (value) => {
  return new Intl.NumberFormat("vi-VN").format(toNumber(value));
};
